export const resolveEmbedScriptUrl = (sitePath: string | undefined): string => {
    const template = process.env.REACT_APP_EMBED_JS_NEXT;
    if (!sitePath || !template) return '';
    return template.replace('{subdomain}', sitePath.toLowerCase());
};
